var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClassesStr},[_c('a',{class:_vm.linkClassesStr,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$router.go(-1)}}},[_vm._v("\n    ← Back\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1518af0d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BackBtn.vue
// module id = 1140
// module chunks = 1